import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import { ERC20 } from '../abi/abi'
import NumericalValue from './NumericalValue'
import { numericalFormatter } from '../utils/num'
import { swaapGreen0, swaapRed0 } from './Themes'
import { Loader } from './Loader'
import { Address, Wei } from '../utils/types'
import { SimpleObserver } from '../utils/Observer'
import Web3 from 'web3'
import { fromWei } from '../utils/static-web3'
import { Token } from '../logic/token/token'
import { Web3Context } from '../hooks/web3'
import { TokenApi } from '../api/web3/token-api'

const PanelCurrencyBalanceTitle = styled.div`
  font-size: 14px;
  text-align: left;
  align-self: center;
  justify-content: left;
`

const PanelCurrencyBalanceValue = styled(NumericalValue)<{
  enoughBalance: boolean | undefined
}>`
  font-family: Montserrat-Light;
  font-size: 1.5rem;
  text-align: left;
  align-self: center;
  margin-left: 0.3em;
  justify-content: left;
  color: ${({ theme, enoughBalance }) =>
    enoughBalance !== undefined
      ? enoughBalance
        ? 'inherited'
        : swaapRed0
      : theme.tradeCurrencyTextColor};
  font-weight: bold;
`

const _PanelCurrencyBalance = styled.div`
  pointer-events: auto;
  font-size: 0.5em;
  text-align: right;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
`
interface Props {
  onBalanceUpdate?: (balance: string | undefined) => void
  token: Token | undefined
  observer?: SimpleObserver
  tokenTargetQuantity?: string
}
function PanelCurrencyBalance(props: Props) {
  // Balance is kept in wei because we need the MAX button to be exact
  // Balance can be undefined if user is not connected
  const { web3, account } = useContext(Web3Context)
  const [balance, setBalance] = useState<string | undefined>(undefined)
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    if (!web3 || !account || !props.token) {
      return
    }
    const tokenApi = new TokenApi(web3, account, props.token)

    tokenApi.getERC20Balance()
      .then((balance: string | undefined) => {
        setBalance(balance)
        setLoading(false)
        if (props.onBalanceUpdate) {
          props.onBalanceUpdate(balance)
        }
      })
      .catch(e => {
        console.error(e)
        setLoading(false)
        setBalance(undefined)
        if (props.onBalanceUpdate) {
          props.onBalanceUpdate(undefined)
        }
      })
  }, [web3 != undefined, account, props.token])

  return (
    <>
      {!loading ? (
        <_PanelCurrencyBalance>
          <PanelCurrencyBalanceValue
            enoughBalance={
              props.tokenTargetQuantity && balance
                ? props.tokenTargetQuantity <= balance
                : undefined
            }
          >
            {balance && Number(balance) > 0 && props.token
              ? numericalFormatter(fromWei(balance, props.token.decimals))
              : 0}
          </PanelCurrencyBalanceValue>
        </_PanelCurrencyBalance>
      ) : (
        <Loader size={'20px'} />
      )}
    </>
  )
}
export default PanelCurrencyBalance
